import React from "react";
import { CalendarOutlined, RocketOutlined, TeamOutlined, TrophyOutlined } from "@ant-design/icons";
import { Avatar, Card, Col, Layout, Row, Space, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

export const About = () => {
  const features = [
    {
      icon: <CalendarOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      title: "Event Management",
      description: "Create, manage, and organize your events with ease using our intuitive calendar interface.",
    },
    {
      icon: <TeamOutlined style={{ fontSize: "32px", color: "#52c41a" }} />,
      title: "Team Collaboration",
      description: "Work together with your team members to plan and execute successful events.",
    },
    {
      icon: <TrophyOutlined style={{ fontSize: "32px", color: "#fa8c16" }} />,
      title: "Success Tracking",
      description: "Monitor your event performance and track success metrics to improve future events.",
    },
    {
      icon: <RocketOutlined style={{ fontSize: "32px", color: "#722ed1" }} />,
      title: "Advanced Features",
      description: "Access powerful tools and integrations to take your event management to the next level.",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <Content style={{ padding: "24px" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* Hero Section */}
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <CalendarOutlined style={{ fontSize: "64px", color: "#1890ff", marginBottom: "24px" }} />
            <Title level={1}>About Calendar App</Title>
            <Paragraph style={{ fontSize: "18px", maxWidth: "600px", margin: "0 auto" }}>
              We're passionate about helping you create, manage, and execute amazing events. Our platform brings
              together powerful tools and intuitive design to make event management simple and effective.
            </Paragraph>
          </div>

          {/* Mission Section */}
          <Row justify="center">
            <Col xs={24} lg={16}>
              <Card>
                <div style={{ textAlign: "center" }}>
                  <Title level={2}>Our Mission</Title>
                  <Paragraph style={{ fontSize: "16px", lineHeight: "1.8" }}>
                    To empower individuals and organizations with the tools they need to create memorable events
                    and meaningful connections. We believe that great events start with great planning, and we're
                    here to make that process as smooth and enjoyable as possible.
                  </Paragraph>
                </div>
              </Card>
            </Col>
          </Row>

          {/* Features Section */}
          <div>
            <Title level={2} style={{ textAlign: "center", marginBottom: "32px" }}>
              What We Offer
            </Title>
            <Row gutter={[24, 24]}>
              {features.map((feature, index) => (
                <Col xs={24} sm={12} lg={6} key={index}>
                  <Card hoverable style={{ height: "200px", textAlign: "center" }}>
                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                      <div>{feature.icon}</div>
                      <Title level={4}>{feature.title}</Title>
                      <Text type="secondary">{feature.description}</Text>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Values Section */}
          <Row justify="center">
            <Col xs={24} lg={16}>
              <Card>
                <div style={{ textAlign: "center" }}>
                  <Title level={2}>Our Values</Title>
                  <Row gutter={[24, 24]} style={{ marginTop: "24px" }}>
                    <Col xs={24} sm={8}>
                      <div>
                        <Title level={4}>Simplicity</Title>
                        <Text type="secondary">We believe in keeping things simple and user-friendly</Text>
                      </div>
                    </Col>
                    <Col xs={24} sm={8}>
                      <div>
                        <Title level={4}>Innovation</Title>
                        <Text type="secondary">Constantly improving and adding new features</Text>
                      </div>
                    </Col>
                    <Col xs={24} sm={8}>
                      <div>
                        <Title level={4}>Support</Title>
                        <Text type="secondary">Providing excellent customer support and resources</Text>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>

          {/* Contact Section */}
          <Row justify="center">
            <Col xs={24} lg={16}>
              <Card>
                <div style={{ textAlign: "center" }}>
                  <Title level={2}>Get in Touch</Title>
                  <Paragraph>
                    Have questions or feedback? We'd love to hear from you. Reach out to us and we'll get back to
                    you as soon as possible.
                  </Paragraph>
                  <Space size="large">
                    <Text strong>Email: support@calendarapp.com</Text>
                    <Text strong>Phone: (555) 123-4567</Text>
                  </Space>
                </div>
              </Card>
            </Col>
          </Row>
        </Space>
      </Content>
    </Layout>
  );
};

export default About;
